import React from 'react';
import styled from 'styled-components';
import { AboutHead, Header, Service, Team, Why } from '../../components/comp';

const Home = () => {
  return (
    <HomeWrapper>
      <Header />
      <AboutHead />
      <Service />
      <Why />
      <Team />
    </HomeWrapper>
  );
};

const HomeWrapper = styled.section`
 overflow-x: hidden;
`;

export default Home;
